import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import Dropdown from '../../../../components/Dropdown';
import CustomAutoComplete from '../../../../components/CustomAutoComplete';
import { searchJobViewRecommend, searchNewsViewRecommend } from 'reducers/companyTalent';
import CheckboxButton from '../../../../components/CheckboxButton';

const ActivitySection = ({ formAdvanceData, setFormAdvanceData }) => {
  const dispatch = useDispatch();
  const { activityLevelOptions, loginTimeOptions, viewJobTimeOptions, jobViewRecommendOptions, newsViewRecommendOptions } = useSelector((state: any) => state.companyTalent);
  const [viewedJobTitle, setViewedJobTitle] = useState("");
  const [viewedNewsTitle, setViewedNewsTitle] = useState("");

  const getMinCreatedAt = () => {
    if(formAdvanceData.created_at_start) {
      return formAdvanceData.created_at_start
    }
    return new Date(2000, new Date().getMonth(), new Date().getDate())
  };

  const getMaxCreatedAt = () => {
    if(formAdvanceData.created_at_end) {
      return formAdvanceData.created_at_end
    }
    return new Date(9999, new Date().getMonth(), new Date().getDate())
  };

  const handleChangeJobViewTitle = (value: any) => {
    setViewedJobTitle(value);
    dispatch(searchJobViewRecommend({ search: value }));
  };

  const handleChangeNewsViewTitle = (value: any) => {
    setViewedNewsTitle(value);
    dispatch(searchNewsViewRecommend({ search: value }));
  };

  return (
    <>
      <p className='text-sm font-bold alu-text-base-2 mb-6'>アクティビティ</p>
      <div className='flex flex-col gap-8'>
        <div className='grid grid-cols-2 gap-10'>
          <div className='col-span-1'>
            <label className="block text-sm mb-2 alu-text-base-1">登録日</label>
            <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <CustomDatePicker
                  placeholderText=""
                  value={formAdvanceData.created_at_start}
                  maxDate={getMaxCreatedAt()}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({
                      ...prev,
                      created_at_start: value,
                    }));
                  }}
                />
              </div>
              <span className='shrink-0'>-</span>
              <div className='flex-1'>
                <CustomDatePicker
                  placeholderText=""
                  value={formAdvanceData.created_at_end}
                  minDate={getMinCreatedAt()}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({
                      ...prev,
                      created_at_end: value,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-1"></div>
        </div>

        <div className='grid grid-cols-6 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">アクセス頻度</label>
            {/* activity_level */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={activityLevelOptions}
              placeholder=""
              value={formAdvanceData.activity_level}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, activity_level: value }))
              }}
            />
          </div>
          <div className="col-span-2">
            <label className="block text-sm mb-2 alu-text-base-1">最終アクセス日時</label>
            {/* access_time */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={loginTimeOptions}
              placeholder=""
              value={formAdvanceData.access_time}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, access_time: value }))
              }}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">求人閲覧頻度</label>
            {/* job_view_level */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={activityLevelOptions}
              placeholder=""
              value={formAdvanceData.job_view_level}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, job_view_level: value }))
              }}
            />
          </div>
          <div className="col-span-2">
            <label className="block text-sm mb-2 alu-text-base-1">最終求人閲覧日時</label>
            {/* last_job_viewed_time */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={viewJobTimeOptions}
              placeholder=""
              value={formAdvanceData.last_job_viewed_time}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, last_job_viewed_time: value }))
              }}
            />
          </div>
        </div>

        <div className='grid grid-cols-2 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">見ている求人</label>
            {/* viewed_job_id */}
            <CustomAutoComplete
              placeholder={"タイトルを入力…"}
              options={jobViewRecommendOptions}
              noOptionsMessage={'検索結果が見つかりませんでした'}
              value={formAdvanceData.viewed_job_obj}
              inputValue={viewedJobTitle}
              onInputChange={handleChangeJobViewTitle}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, viewed_job_id: value?.value, viewed_job_obj: value }))
              }}
              isCustomOption={false}
              isClearable={true}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">見ているコンテンツ</label>
            {/* viewed_new_id */}
            <CustomAutoComplete
              placeholder={"タイトルを入力…"}
              options={newsViewRecommendOptions}
              noOptionsMessage={'検索結果が見つかりませんでした'}
              value={formAdvanceData.viewed_new_obj}
              inputValue={viewedNewsTitle}
              onInputChange={handleChangeNewsViewTitle}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, viewed_new_id: value?.value, viewed_new_obj: value }))
              }}
              isCustomOption={false}
              isClearable={true}
            />
          </div>
        </div>

        <div className='grid grid-cols-3 gap-10'>
          <div className='col-span-1'>
            <div onClick={(e) => {
                e.stopPropagation();
                setFormAdvanceData((prev) => ({
                  ...prev,
                  withdrawn_talent_included: formAdvanceData.withdrawn_talent_included ? null : true,
                }));
            }} className="w-full px-3 py-[0.375rem] flex items-center gap-3 rounded-[0.25rem] border border-[#E0E0E0] hover:bg-[#FFF3E5] hover:cursor-pointer">
                <div className="shrink-0">
                  <CheckboxButton
                    name={'withdrawn_talent_included'}
                    label={'退会済みタレントを表示'}
                    value={Boolean(formAdvanceData.withdrawn_talent_included)}
                    onChange={(e:any) => {
                      setFormAdvanceData((prev) => ({
                        ...prev,
                        withdrawn_talent_included: formAdvanceData.withdrawn_talent_included ? null : true,
                      }));
                    }}
                  />
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ActivitySection